module.exports = __webpack_public_path__ + "6148b120a163f2d122fbafa4c02248f7.png";